import { useSelector } from "react-redux";

const useFeatures = () => {
  return useSelector((state) => state.features);
};

export const useDeliveryCountries = () => {
  const carriersSpecs = useSelector((state) => state.features.carriers_specificities);

  return carriersSpecs.map((country) => country.iso_3166).sort();
};

export const useFiltersList = () => {
  return useSelector((state) => state.features?.filters_list);
};

export const useReferralProgram = () => {
  return useSelector((state) => state.features?.referral_program);
};

export default useFeatures;
